import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@shared/api/client";

export interface Notificacion {
  id: number;
  tipo: string;
  titulo: string;
  mensaje: string | null;
  url: string | null;
  leida_en: string | null;
  creado_en: string;
}

const BASE = "/notifications";
const key = ["notifications"] as const;

export function useNotifications() {
  return useQuery({
    queryKey: key,
    queryFn: async () =>
      (await api.get<{ data: Notificacion[]; no_leidas: number }>(BASE)).data,
    refetchInterval: 60_000,
  });
}

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => (await api.post(`${BASE}/${id}/read`)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post(`${BASE}/read-all`)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}
